import React, { useEffect, useRef, useState } from 'react';
import { FormControl, Select, MenuItem, Box } from '@mui/material';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useSnackbar } from '../SnackBar';
import { useProgressBar } from '../ProgressBar';
import { useParams,useNavigate } from 'react-router-dom';

const EditPackage = () => {
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const { id, edit } = useParams();
    // Predefined list of services
    const { partnerservice, GetPartnerServices, GetAdditionalServices, additionalService, AddPackage, GetPackageById, UpdatePackage } = useServiceContext();
    const navigate = useNavigate();
    const [serviceId, setServiceId] = useState([]);
    const [additionalName, setAdditionalName] = React.useState([]);
    const [selectedAddSer, setAddServ] = useState([]);
    const handleCategoryChange = (serviceIndex, serviceId) => {
        const updatedServices = [...packageData.services];
        updatedServices[serviceIndex].serviceId = serviceId;
        setPackageData({ ...packageData, services: updatedServices });
        GetAdditionalServices(serviceId)
    };
    const handleQuantityChange = (serviceIndex, quantity) => {
        const updatedServices = [...packageData.services];
        updatedServices[serviceIndex].quantity = quantity;
        setPackageData({ ...packageData, services: updatedServices });
    };

    const handleAddServChange = (serviceIndex, selectedValues) => {
        const updatedServices = [...packageData.services];
        updatedServices[serviceIndex].additionalService = selectedValues;
        setPackageData({ ...packageData, services: updatedServices });
    };
   
  
    const [packageData, setPackageData] = React.useState({
        packageName: "",
        packagePrice: 0,
        description: "",
        isApproved: true,
        isActive: true,
        services: [],
    });
    const [partnerservices, setPartnerService] = React.useState([]);
    const [additionalServices, setAdditionalService] = React.useState([]);
    
   
    const handleServiceChange = (serviceIndex, field, value) => {
        const updatedServices = [...packageData.services];
        updatedServices[serviceIndex] = {
            ...updatedServices[serviceIndex],
            [field]: value,
        };
        setPackageData({ ...packageData, services: updatedServices });
    };

    const handleAddedServiceChange = (serviceIndex, addedIndex, field, value) => {
        const updatedServices = [...packageData.services];
        const updatedAddedServices = [...updatedServices[serviceIndex].addedServices];
        updatedAddedServices[addedIndex] = {
            ...updatedAddedServices[addedIndex],
            [field]: value,
        };
        updatedServices[serviceIndex].addedServices = updatedAddedServices;
        setPackageData({ ...packageData, services: updatedServices });
    };

    const removeAddedService = (serviceIndex, addedIndex) => {
        const updatedServices = [...packageData.services];
        const updatedAddedServices = [...updatedServices[serviceIndex].addedServices];
        updatedAddedServices.splice(addedIndex, 1);
        updatedServices[serviceIndex].addedServices = updatedAddedServices;
        setPackageData({ ...packageData, services: updatedServices });
    };

    const addAddedService = (serviceIndex) => {
        const updatedServices = [...packageData.services];
        const newAddedService = {
            id: 0,
            name: '',
            isActive: true,
            isDeleted: false,
        };
        updatedServices[serviceIndex].addedServices = [
            ...updatedServices[serviceIndex].addedServices,
            newAddedService,
        ];
        setPackageData({ ...packageData, services: updatedServices });
    };

    const addService = () => {
        setPackageData((prevData) => ({
            ...prevData,
            services: [
                ...prevData.services,
                {
                    serviceId: 0,
                    quantity: 0,
                    additionalService: [],
                },
            ],
        }));
    };

    const removeService = (serviceIndex) => {
        const updatedServices = [...packageData.services];
        updatedServices.splice(serviceIndex, 1);
        setPackageData({ ...packageData, services: updatedServices });
    };
    const handleSubmit = async (e) => {
        if (!packageData.packageName.trim() || !packageData.packagePrice || !packageData.description) {
            showSnackbar('Package details should be filled', 'warning');
        } else {

            showProgress(true);
            e.preventDefault();
           const up= await UpdatePackage(packageData);
           
            showSnackbar('Package updated successfully', 'success');
            showProgress(false);
            setTimeout(() => {
                navigate(`/viewpackage/${up.packageId}/false`)
            }, 2000);
        }
    };
    const didFetch = useRef(false);
    const getData = async () => {
        try {
            await GetPartnerServices();
            const d = await GetPackageById(id);
            
            setPackageData(d);
            const ServiceArray = d.services.map(item => item.serviceId);
            ServiceArray.forEach(element => {
                GetAdditionalServices(element)
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });
    return(
        <main id="main" className="main">
        <div className="pagetitle">
              <h1>Package</h1>
              <nav>
                  <ol className="breadcrumb">
                      <li className="breadcrumb-item"><a href="/branch">Home</a></li>
                        <li className="breadcrumb-item"><a href="/viewpackage">Packages</a></li>
                    
                  </ol>
              </nav>
        </div>
        <section className="section">
            <div className="row">
                  <div className="col-lg-12">
                  <div className="card">
                  <div className="card-body">
                  <h5 className="card-title">Package Details</h5>
                <div>
                       
                                    <form>
                                        {/* Package Name */}
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <strong>Package Name:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm w-50"
                                                    id="packageName"
                                                    placeholder="Enter Package Name"
                                                    value={packageData.packageName}
                                                    onChange={(e) => setPackageData({ ...packageData, packageName: e.target.value })}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        {/* Package Description */}
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <strong>Description:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <textarea
                                                    className="form-control form-control-sm w-50"
                                                    id="description"
                                                    rows="3"
                                                    placeholder="Enter Package Description"
                                                    value={packageData.description}
                                                    onChange={(e) => setPackageData({ ...packageData, description: e.target.value })}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        {/* Package Price */}
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <strong>Package Price:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm w-50"
                                                    id="packagePrice"
                                                    placeholder="Enter Package Price"
                                                    value={packageData.packagePrice}
                                                    onChange={(e) => setPackageData({ ...packageData, packagePrice: parseFloat(e.target.value) })}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        {/* Services */}
                                        {packageData.services.map((service, serviceIndex) => (
                                            <div key={serviceIndex}>
                                                <div className="row mb-3">
                                                    <div className="col-md-3">
                                                        <strong>Service:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <FormControl fullWidth className="form-control-custom">
                                                            <Select
                                                                value={service.serviceId}
                                                                onChange={(e) => handleCategoryChange(serviceIndex, e.target.value)}
                                                            >
                                                                {partnerservice.map((category) => (
                                                                    <MenuItem key={category.id} value={category.id}>
                                                                        {category.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>

                                                <div className="row mb-3">
                                                    <div className="col-md-3">
                                                        <strong>Quantity:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm form-control-custom"
                                                            value={service.quantity}
                                                            onChange={(e) => handleQuantityChange(serviceIndex, parseInt(e.target.value))}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-3">
                                                    <div className="col-md-3">
                                                        <strong>Added Services:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <FormControl fullWidth className="form-control-custom">
                                                            <Select
                                                                multiple
                                                                value={service.additionalService}
                                                                onChange={(e) => handleAddServChange(serviceIndex, e.target.value)}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                                        {selected.map((id) => {
                                                                            const selectedItem = additionalService.find((item) => item.id === id);
                                                                            return <Chip key={id} label={selectedItem?.name} />;
                                                                        })}
                                                                    </Box>
                                                                )}
                                                            >
                                                                {additionalService.map((value) => (
                                                                    <MenuItem key={value.id} value={value.id}>
                                                                        <Checkbox checked={service.additionalService.includes(value.id)} />
                                                                        <ListItemText primary={value.name} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                  
                                                </div>
                                               
                                                <div className="row mb-3">
                                                    <div className="col-md-3">
                                                       
                                                    </div>
                                                    <div className="col-md-8 d-flex justify-content-end">
                                                        <button type="button" className="btn btn-primary btn-sm w-auto" onClick={() => removeService(serviceIndex)} >
                                                            Remove
                                                        </button>
                                                    </div>
                                                  
                                                </div>
                                              
                                            </div>
                                        ))}


                                        <button type="button" className="btn btn-primary btn-sm w-auto mt-3" onClick={addService}>
                                            Add Another Service
                                        </button>

                                        {/* Submit Button */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <button type="button" className="btn btn-primary btn-sm w-auto" onClick={handleSubmit}>
                                                Save Package
                                            </button>
                                        </div>
                                    </form>
                                    </div>


                  </div>
                  </div>
                  </div>
                  </div>
        </section>
</main>




    );

};
export default EditPackage;